









import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Page extends Vue {
  @Prop({ default: () => true }) fullscreen!: boolean;

  public $refs!: {
    page: HTMLElement;
  };

  public pageClassList: any = {
    fullscreen: false
  };

  public mounted() {
    console.log(this.pageClassList);
    if (this.fullscreen) {
      this.pageClassList.fullscreen = true;
    }
  }
}
